import React, { useState, useCallback, useImperativeHandle, forwardRef } from 'react';
import ToastItem from './ToastItem';
import { ToastMessage } from './types';
import  './index.scss';

interface ToastContainerProps {}

export interface ToastContainerRef {
    addToast: (toast: ToastMessage) => void;
}

const ToastContainer = forwardRef<ToastContainerRef, ToastContainerProps>((_, ref) => {
    const [toasts, setToasts] = useState<ToastMessage[]>([]);

    const addToast = useCallback((toast: ToastMessage) => {
        setToasts((currentToasts) => [...currentToasts, toast]);
    }, []);

    const removeToast = useCallback((id: string) => {
        setToasts((currentToasts) => currentToasts.filter((toast) => toast.id !== id));
    }, []);

    useImperativeHandle(ref, () => ({
        addToast,
    }));

    // 基本容器样式，请根据您的需求调整位置等
    const containerStyle: React.CSSProperties = {
        position: 'fixed',
        top: '20px',
        right: '20px',
        zIndex: 9999, // 确保在顶层
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    };

    return (
        <div className="toast-container" style={containerStyle}>
            {toasts.map((toast) => (
                <ToastItem key={toast.id} toast={toast} onRemove={removeToast} />
            ))}
        </div>
    );
});

ToastContainer.displayName = 'ToastContainer';
export default ToastContainer;
